ready(function() {
  let class_name = null;
  
  // touch device? (mobile)
  let l = document.createElement('p');
  if (l.ontouchstart !== undefined)
    class_name = 'touch';
  else
    class_name = 'desktop';
  
  if (class_name)
    document.querySelector('html').classList.add(class_name);
});



// WEBPACK FOOTER //
// ./app/javascript/components_common/detect-device.js